import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthStore } from '../services/auth.store';

export const appGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (!authStore.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (authStore.loaded()) {
    return true;
  }

  return authStore.bootstrapSession(true).pipe(
    map((isReady) => (isReady ? true : router.createUrlTree(['/login']))),
  );
};
